export var MainPointOutType;
(function (MainPointOutType) {
    MainPointOutType["AI"] = "ai";
    MainPointOutType["LINT"] = "lint";
})(MainPointOutType || (MainPointOutType = {}));
export var RuleType;
(function (RuleType) {
    RuleType["USER_DIC"] = "user-dic";
    RuleType["CLIENT_DIC"] = "client-dic";
    RuleType["ADMIN_DIC"] = "admin-dic";
    RuleType["OTHER"] = "admin-rule";
})(RuleType || (RuleType = {}));
export const pointPutTypeOrder = {
    [RuleType.USER_DIC]: 1,
    [RuleType.CLIENT_DIC]: 2,
    [MainPointOutType.AI]: 3,
    [RuleType.ADMIN_DIC]: 4,
    [RuleType.OTHER]: 5,
    [MainPointOutType.LINT]: 6
};
export const mainPointOutTypeOrder = {
    [MainPointOutType.AI]: 1,
    [MainPointOutType.LINT]: 2,
};
export const ruleTypeOrder = {
    [RuleType.USER_DIC]: 3,
    [RuleType.CLIENT_DIC]: 4,
    [RuleType.ADMIN_DIC]: 5,
    [RuleType.OTHER]: 6
};
